import React from "react";
import { Link, Outlet } from "react-router-dom";
// import "../../../css/admin.module.css";
import "../../../css/admin.css";

const BlogManagement = () => (
  <div className="blog-management">
    <h1>مدیریت بلاگ</h1>

    <div className="blog-management-actions">
      {/* مدیریت پست‌ها */}
      <Link to="posts" className="blog-management-button">
        فهرست پست‌ها
      </Link>
      <Link to="posts/add" className="blog-management-button">
        افزودن پست
      </Link>

      {/* مدیریت دسته‌بندی‌ها */}
      <Link to="categories" className="blog-management-button">
        فهرست دسته‌بندی‌ها
      </Link>
      <Link to="categories/add" className="blog-management-button">
        افزودن دسته‌بندی
      </Link>

      {/* مدیریت برچسب‌ها */}
      <Link to="tags" className="blog-management-button">
        فهرست برچسب‌ها
      </Link>
      <Link to="tags/add" className="blog-management-button">
        افزودن برچسب
      </Link>
    </div>

    <div className="blog-management-content">
      <Outlet />
    </div>
  </div>
);

export default BlogManagement;